import { render } from "./studentregistration.vue?vue&type=template&id=cf159e48&scoped=true"
import script from "./studentregistration.vue?vue&type=script&lang=js"
export * from "./studentregistration.vue?vue&type=script&lang=js"

import "./studentregistration.vue?vue&type=style&index=0&id=cf159e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf159e48"]])

export default __exports__